module.exports = __webpack_public_path__ + "static/manna-web-ba88e38643d53a682e4787543f162eee.jpg";